import { Button } from "@wise-emotions/react-button";
import { PrivateAreaCta } from "components/HeaderNew/HeaderFull/types";
import React from "react";

type Props = {
  privateArea: PrivateAreaCta[];
};

const PrivateAreaButtons = ({ privateArea }: Props) =>
  privateArea.map(({ ctaLabel, ctaTheme, ctaAnchor }) => (
    <Button
      key={ctaLabel}
      variant="default"
      theme={ctaTheme}
      size="md"
      {...ctaAnchor}
    >
      {ctaLabel}
    </Button>
  ));

export default PrivateAreaButtons;
